export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"}],"style":[],"script":[{"key":"consent","data-cookieconsent":"ignore","children":"window.dataLayer = window.dataLayer || [];\n            function gtag() {\n              dataLayer.push(arguments)\n            }\n            gtag(\"consent\", \"default\", {\n              ad_personalization: \"denied\",\n              ad_storage: \"denied\",\n              ad_user_data: \"denied\",\n              analytics_storage: \"denied\",\n              functionality_storage: \"denied\",\n              personalization_storage: \"denied\",\n              security_storage: \"granted\",\n              wait_for_update: 500\n            });\n            gtag(\"set\", \"ads_data_redaction\", true);\n            gtag(\"set\", \"url_passthrough\", true);"},{"key":"gtagHead","data-cookieconsent":"ignore","hid":"gtagHead","innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-TCTNST2Z');","tagPriority":"after:script:consent"},{"key":"cookiebot","src":"https://consent.cookiebot.com/uc.js","data-cbid":"01329a2d-0b46-4689-bf00-62310677e33c","type":"text/javascript","async":true,"tagPriority":"after:script:gtagHead"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'